import { render, staticRenderFns } from "./resume-contacts-view.vue?vue&type=template&id=7d56f7fc&scoped=true&"
import script from "./resume-contacts-view.vue?vue&type=script&lang=js&"
export * from "./resume-contacts-view.vue?vue&type=script&lang=js&"
import style0 from "./resume-contacts-view.vue?vue&type=style&index=0&id=7d56f7fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d56f7fc",
  null
  
)

export default component.exports